import PropTypes from 'prop-types'
import { memo } from 'react'

import { StyledLogoContainer, StyledLogoImage } from './styles'

const Logo = ({ widescreenConfig }) => {

  if (!widescreenConfig?.useLogo || !widescreenConfig?.logo) {
    return null
  }

  const handleImageError = (e) => {
    console.error('Widescreen Logo - Image failed to load:', widescreenConfig.logo, e)
  }

  const handleImageLoad = () => {
    console.log('Widescreen Logo - Image loaded successfully:', widescreenConfig.logo)
  }

  return (
    <StyledLogoContainer
      $backgroundColor={widescreenConfig.backgroundLogoColor || widescreenConfig.logoThemeColor}
      $logoPosition={widescreenConfig.logoPosition}
      $width={widescreenConfig.logoWidth}
      $useTransparent={widescreenConfig?.useTransparent}
    >
      <StyledLogoImage
        crossOrigin={"anonymous"}
        src={widescreenConfig.logo}
        alt="Logo"
        $logoPosition={widescreenConfig.logoPosition}
        onError={handleImageError}
        onLoad={handleImageLoad}
        $backgroundColor={widescreenConfig.backgroundLogoColor || widescreenConfig.logoThemeColor}
      />
    </StyledLogoContainer>
  )
}

Logo.propTypes = {
  widescreenConfig: PropTypes.object,
}

export default memo(Logo)
